import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function CapitalMarketSEBI() {
  const [activeTab, setActiveTab] = useState("capital");
  const navigate = useNavigate();

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/Achievements.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Capital Market & SEBI Advisory Services</h1>
          <p>
            Comprehensive advisory, audit, and compliance services for capital
            market participants, intermediaries, and corporates.
          </p>
        </div>
      </section>

      {/* ===== TAB NAVIGATION ===== */}
      <div className="tax-tabs">
        <button
          className={activeTab === "capital" ? "active" : ""}
          onClick={() => handleTabClick("capital", "/capital-market-sebi")}
        >
          Capital Market & SEBI Advisory
        </button>

        <button
          className={activeTab === "depository" ? "active" : ""}
          onClick={() =>
            handleTabClick("depository", "/depository-participant-audit")
          }
        >
          Depository Participant (DP) Audit – NSDL/CDSL
        </button>

        <button
          className={activeTab === "system" ? "active" : ""}
          onClick={() =>
            handleTabClick("system", "/system-audit-capital-market")
          }
        >
          System Audit for Capital Market Intermediaries
        </button>

        <button
          className={activeTab === "exchange" ? "active" : ""}
          onClick={() =>
            handleTabClick("exchange", "/exchange-sebi-compliances")
          }
        >
          Exchange & SEBI Compliances
        </button>

        <button
          className={activeTab === "ipo" ? "active" : ""}
          onClick={() => handleTabClick("ipo", "/ipo-listing-support")}
        >
          IPO & Listing Support
        </button>
      </div>

      {/* ===== SERVICE DETAILS ===== */}
      <section className="container dp-section">
        {/* INTRO */}
        <div className="row">
          <div className="col-md-12 mt-5">
            <h2 className="section-title mb-4">
              Capital Market & SEBI Advisory Services
            </h2>

            <p className="service-text">
              Navigating India’s capital market ecosystem requires strict
              compliance with SEBI regulations, stock exchange norms, and
              depository guidelines. Market participants and companies must
              ensure operational integrity, transparency, and timely regulatory
              adherence.
            </p>

            <p className="service-text mt-3">
              At <strong>S D P M & Co.</strong>, we provide end-to-end capital
              market advisory and compliance services covering audits, system
              reviews, regulatory filings, and listing support—helping businesses
              remain compliant, structured, and investor-ready.
            </p>
          </div>
        </div>

        {/* SECTION TITLE */}
        <h3 className="dp-section-title mt-4">
          Our Capital Market Service Coverage
        </h3>

        {/* CARD 1 */}
        <div className="row">
          <div className="col-md-6">
            <div className="dp-card">
              <h4>1. Depository Participant (DP) Audit – NSDL / CDSL</h4>
              <ul>
                <li>Statutory DP audits as prescribed by SEBI and Depositories</li>
                <li>
                  Review of operational controls, records, and investor
                  protection measures
                </li>
                <li>
                  Identification of compliance gaps and corrective action
                  support
                </li>
                <li>
                  Assistance in regulatory reporting and audit observations
                </li>
              </ul>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>2. System Audit for Capital Market Intermediaries</h4>
              <ul>
                <li>System audits as mandated by SEBI for intermediaries</li>
                <li>
                  Review of IT systems, cybersecurity controls, and data
                  integrity
                </li>
                <li>
                  Assessment of system adequacy, access controls, and backups
                </li>
                <li>Audit reporting as per SEBI-prescribed formats</li>
              </ul>
            </div>
          </div>
        </div>

        {/* CARD 3 */}
        <div className="row mt-3">
          <div className="col-md-6">
            <div className="dp-card">
              <h4>3. Exchange & SEBI Compliances</h4>
              <ul>
                <li>
                  Advisory on exchange and SEBI regulatory requirements
                </li>
                <li>Periodic compliance review and monitoring</li>
                <li>
                  Assistance in filings, disclosures, and regulatory
                  correspondence
                </li>
                <li>
                  Support during inspections and regulatory reviews
                </li>
              </ul>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>4. IPO & Listing Support</h4>
              <ul>
                <li>Pre-IPO compliance readiness assessment</li>
                <li>Advisory on SEBI (ICDR) requirements</li>
                <li>
                  Coordination with merchant bankers and other intermediaries
                </li>
                <li>
                  Post-listing compliance and governance support
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      {/* <div className="row mt-4">
        <div className="col-md-12">
          <div className="nri-highlight">
            <h3 className="mb-3">Why Choose Us?</h3>
            <ul>
              <li>
                Experienced professionals in capital market & SEBI regulations
              </li>
              <li>
                Strong understanding of depository, exchange, and intermediary
                frameworks
              </li>
              <li>
                End-to-end support across audit, compliance, and listing
                lifecycle
              </li>
              <li>
                Practical, risk-focused advisory approach
              </li>
              <li>
                High standards of confidentiality and regulatory accuracy
              </li>
            </ul>
          </div>
        </div>
      </div> */}

      <Footer />
    </>
  );
}
